import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { ReportesInterfazContableComponent } from './ReportesInterfazContable.component';


import { RoleGuardService as RoleGuard } from '../Seguridad/role-guard.service';





const routes = [
    {
        path     : 'ReportesInterfazContable',
        component: ReportesInterfazContableComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ReportesInterfazContable',
          nombreFormulario : 'ReportesInterfazContable'
        } 
    }
];

@NgModule({
    declarations: [
        ReportesInterfazContableComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        ReportesInterfazContableComponent
    ]
})

export class ReportesInterfazContableModule
{
}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/InterfazContable/ReportesInterfazContable.module.ts